export const formatSumRu = value => {
  const num = Number(value);

  if (!Number.isFinite(num)) {
    return '0';
  }

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
